import { cloneDeep } from "lodash";
import type { GivenNameExactness, SurnameExactness } from "@searchui-searchforms/shared/canonicalizer";

type NameExactness = GivenNameExactness | SurnameExactness;

/** True when the exactness is pure "Exact" — exact match with no fuzzy flags set. */
export const isExactOnly = (value: NameExactness): boolean =>
    value.isExact && Object.values(value.flags).every((flag) => !flag);

/** Returns a copy of the exactness forced to pure "Exact" (exact match, all fuzzy flags cleared). */
export const toExactOnly = <T extends NameExactness>(value: T): T => {
    const next = cloneDeep(value);
    next.isExact = true;
    const { flags } = next as NameExactness;
    for (const id of Object.keys(flags) as (keyof typeof flags)[]) {
        flags[id] = false;
    }
    return next;
};
